// export const IMG_URL = "http://127.0.0.1:1919";
// export const IMG_URL = "https://navsiddhi.node.profcymabackend.com:4326";

// export const IMG_URL = "https://mywealthwave.hostelbliss.com:4343";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

// export const formatTime = (dateString) => {
//   if (!dateString) return "";

//   const date = new Date(dateString);

//   const hours = String(date.getHours()).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");

//   return `${hours}:${minutes}:${seconds}`;
// };

export const formatTime = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const FixIDS = {
  Roles: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  Users: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  Privacy_and_Policy: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  Terms_and_Conditions: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  Blog: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  Final_Thought: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  Banner: { List: 41, Add: 42, Edit: 43, Delete: 44 },
  Property_Type: { List: 45, Add: 46, Edit: 47, Delete: 48 },
  Sub_Property: { List: 49, Add: 50, Edit: 51, Delete: 52 },
  Furnishing_Type: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  Parking_Space: { List: 57, Add: 58, Edit: 59, Delete: 60 },
  BHK: { List: 61, Add: 62, Edit: 63, Delete: 64 },
  Floor_Preference: { List: 65, Add: 66, Edit: 67, Delete: 68 },
  Legal_Question: { List: 69, Add: 70, Edit: 71, Delete: 72 },
  Builder: { List: 73, Add: 74, Edit: 75, Delete: 76 },
  Step_Feature: { List: 77, Add: 78, Edit: 79, Delete: 80 },
  Security: { List: 81, Add: 82, Edit: 83, Delete: 84 },
  Restriction: { List: 85, Add: 86, Edit: 87, Delete: 88 },
  Sale_Type: { List: 89, Add: 90, Edit: 91, Delete: 92 },
  Amenity: { List: 93, Add: 94, Edit: 95, Delete: 96 },
  Property: { List: 97, Add: 98, Edit: 99, Delete: 100 },
  User_Question: { List: 101, Add: 102 },
  Coupon: { List: 103, Add: 104, Edit: 105, Delete: 106 },
  Subscription: { List: 107, Add: 108, Edit: 109, Delete: 110 },
  App_Setup: { List: 111, Edit: 112 },
  User_Subscription: { List: 113 },
  User_Information: { List: 114 },
  Appointment_Booking: { List: 115 },
  Best_Price_Property: { List: 116, Edit: 117 },
  Reinspection: { List: 118 },
  Subject: { List: 119, Add: 120, Edit: 121, Delete: 122 },
  Ticket: { List: 123 },
  Kyc: { List: 124, Edit: 125 },
  Property_Document: { List: 126, Add: 127 },
  Review: { List: 128, Add: 129, Edit: 130, Delete: 131 },
  Resell_Property: { List: 132, Edit: 133 },
  Inspection_Appointment: { List: 134 },
  Wallet_History: { List: 135, Edit: 136 },
  Legal_Advisor_Appointment: { List: 137 },
  Inquiry: { List: 138 },
  Project: { List: 139, Add: 140, Edit: 141, Delete: 142 },
  User_Activity: { List: 143, Add: 144 },
  Legal_Verification: { List: 145, Edit: 146 },
  Purpose_Of_Appointment: { List: 147, Add: 148, Edit: 149, Delete: 150 },
  User_Notification: { List: 151, Add: 152, Edit: 153, Delete: 154 },
  Sales: { List: 155, Add: 156, Edit: 157, Delete: 158 },
  User_Rating: { List: 162 },
  Contact_Us: { List: 163 },
  Appointment_Booking_History: { List: 164 },
  Risk_Assessment: { List: 165, Add: 166, Edit: 167, Delete: 168 },
  Property_Making_Status: { List: 169, Add: 170, Edit: 171, Delete: 172 },
};
